import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FilterSelectProps<T extends string> {
  label: string;
  value: T;
  options: {
    value: T;
    label: string;
  }[];
  onChange: (value: T) => void;
}

/** Compact labelled native select — keyboard and screen-reader friendly. */
export function FilterSelect<T extends string>({
  label,
  value,
  options,
  onChange
}: FilterSelectProps<T>) {
  const active = value !== 'alle';
  return <label className="relative inline-flex items-center" data-id="element-50" data-mp="2wt32ikorfvy4">
      <span className="sr-only" data-id="element-51" data-mp="2ru095xi57e5z">{label}</span>
      <select value={value} onChange={e => onChange(e.target.value as T)} className={`h-9 appearance-none whitespace-nowrap rounded-full border pl-3.5 pr-8 text-[13px] font-medium transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60 ${active ? 'border-accent/40 bg-accent/10 text-ink' : 'border-white/10 bg-white/[0.03] text-ink-soft hover:border-white/20'}`} data-id="element-52" data-mp="2rvb9togak5sv">
        {options.map(o => <option key={o.value} value={o.value} className="bg-night-900 text-ink" data-id="element-53" data-mp="32cv6kue2ktl2">
            {o.value === 'alle' ? `${label}: alle` : o.label}
          </option>)}
      </select>
      <ChevronDownIcon className="pointer-events-none absolute right-2.5 h-3.5 w-3.5 text-ink-muted" aria-hidden data-id="element-54" data-mp="2tavorzv8dlh2" />
    </label>;
}